export const columns = [
  {
    title: "Nombre",
    dataIndex: "role_nombre",
    width: "30%",
  },
];
export const formatData = (data) => {
  return {
    idRol: data.id,
    role_nombre: data.role_nombre,
  };
};

export const camposFormulario = {
  title: "Roles",
  campos: [
    {
      name: "idRol",
      label: "id",
      type: "number",
      hidden: true,
    },
    {
      name: "role_nombre",
      label: "Nombre del Rol",
      type: "text",
      rules: [
        {
          required: true,
          message: "El nombre del rol es obligatorio",
        },
        {
          max: 45,
          message: "El nombre no puede exceder los 45 caracteres",
        },
        {
          min: 1,
          message: "El nombre debe tener al menos 1 caracter",
        },
      ],
    },
  ],
};
export const camposFilter = {
  title: "Roles",
  campos: [
    {
      name: "role_nombre",
      type: "text",
      placeholder: "Nombre del Rol",
      rules: [
        {
          max: 45,
          message: "El nombre no puede exceder los 45 caracteres",
        },
      ],
    },
  ],
};
